import React, { useState, useEffect } from 'react'

import { Table, TableHead, TableBody, TableRow, TableCell, TextField, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Grid, Typography, Divider } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const template = {
  ZONE: {
    DOM: {
      DESKTOP: {
        DISPLAY: "",
        OUTSTREAM: "",
      },
      MOBILE: {
        DISPLAY: "",
        OUTSTREAM: "",
      }
    },
    INTL: {
      DESKTOP: {
        DISPLAY: "",
        OUTSTREAM: "",
      },
      MOBILE: {
        DISPLAY: "",
        OUTSTREAM: "",
      }
    },
  },
  PUB_ID: {
    DOM: {
      DESKTOP: 0,
      MOBILE: 0
    },
    INTL: {
      DESKTOP: 0,
      MOBILE: 0
    },
  },
  SLOT: {
    DOM: {
      DESKTOP: {
        DISPLAY: {
          ROS: {
            RECT: { BTF: { "06": 1352345 }, "300x250": 1388591 },
            BNR: { ATF: { "01": { "728x90": 1388592 } } },
            RIGHT: { ATF: { "01": { "300x250": 1388591 } } },
            MULTI: { ATF: { "01": 1352345 }, "728x90": 1388592, default: 1388591 }
          }
        }
      },
      MOBILE: {
        DISPLAY: {
          ROS: {
            RECT: { BTF: { "06": 1352345 }, "300x250": 1388591 },
            MULTI: { ATF: { "01": 1352345 }, default: 1388591 }
          }
        }
      }
    },
    INTL: {
      DESKTOP: {
        DISPLAY: {
          ROS: {
            RECT: { BTF: {}, "300x250": "" },
            BNR: { ATF: {} },
            RIGHT: { ATF: {} },
            MULTI: { ATF: {}, "728x90": "", default: "" }
          }
        }
      },
      MOBILE: {
        DISPLAY: {
          ROS: {
            RECT: { BTF: {}, "300x250": "" },
            MULTI: { ATF: {}, default: "" }
          }
        }
      }
    },
  },
}

export const GumGum = ({ expandAllVendors, options, allOptions, setOptions, setAllOptions, errors, setErrors, validation }) => {
  const { PREBID } = options
  const { VENDOR } = PREBID
  const GUMGUM = { ...template, ...VENDOR.GUMGUM }  
  PREBID.VENDOR.GUMGUM = GUMGUM
  const { ZONE, PUB_ID, SLOT } = GUMGUM

  const [expanded, setExpanded] = useState(expandAllVendors)
  const { STRING } = validation
  const { LENGTH } = STRING

  useEffect(() => {
    setExpanded(expandAllVendors)
  }, [expandAllVendors])

  const displayZoneIDTable = () => {
    return (
      <Table size='small' aria-label='gumgum-zone-id-table'>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: '180px' }}><Typography variant='h6' style={{ fontWeight: 'bolder' }}>Zone ID</Typography></TableCell>
            <TableCell colSpan={2} style={{ textAlign: 'center' }}>DOMESTIC</TableCell>
            <TableCell colSpan={2} style={{ textAlign: 'center' }}>INTERNATIONAL</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ width: '180px' }}></TableCell>
            <TableCell style={{ textAlign: 'center' }}>DESKTOP</TableCell>
            <TableCell style={{ textAlign: 'center' }}>MOBILE</TableCell>
            <TableCell style={{ textAlign: 'center' }}>DESKTOP</TableCell>
            <TableCell style={{ textAlign: 'center' }}>MOBILE</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Display</TableCell>
            <TableCell style={{ verticalAlign: 'top', textAlign: 'center' }}>
              <TextField
                margin='none'
                value={ZONE.DOM.DESKTOP.DISPLAY}
                error={errors.PREBID_GUMGUM_ZONE_DD_DISPLAY}
                helperText={errors.PREBID_GUMGUM_ZONE_DD_DISPLAY && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.GUMGUM.ZONE.DOM.DESKTOP.DISPLAY = value
                  setErrors({ ...errors, PREBID_GUMGUM_ZONE_DD_DISPLAY: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
            <TableCell style={{ verticalAlign: 'top', textAlign: 'center' }}>
              <TextField
                margin='none'
                value={ZONE.DOM.MOBILE.DISPLAY}
                error={errors.PREBID_GUMGUM_ZONE_DM_DISPLAY}
                helperText={errors.PREBID_GUMGUM_ZONE_DM_DISPLAY && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.GUMGUM.ZONE.DOM.MOBILE.DISPLAY = value
                  setErrors({ ...errors, PREBID_GUMGUM_ZONE_DM_DISPLAY: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
            <TableCell style={{ verticalAlign: 'top', textAlign: 'center' }}>
              <TextField
                margin='none'
                value={ZONE.INTL.DESKTOP.DISPLAY}
                error={errors.PREBID_GUMGUM_ZONE_ID_DISPLAY}
                helperText={errors.PREBID_GUMGUM_ZONE_ID_DISPLAY && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.GUMGUM.ZONE.INTL.DESKTOP.DISPLAY = value
                  setErrors({ ...errors, PREBID_GUMGUM_ZONE_ID_DISPLAY: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
            <TableCell style={{ verticalAlign: 'top', textAlign: 'center' }}>
              <TextField
                margin='none'
                value={ZONE.INTL.MOBILE.DISPLAY}
                error={errors.PREBID_GUMGUM_ZONE_IM_DISPLAY}
                helperText={errors.PREBID_GUMGUM_ZONE_IM_DISPLAY && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.GUMGUM.ZONE.INTL.MOBILE.DISPLAY = value
                  setErrors({ ...errors, PREBID_GUMGUM_ZONE_IM_DISPLAY: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Outstream</TableCell>
            <TableCell style={{ verticalAlign: 'top', textAlign: 'center' }}>
              <TextField
                margin='none'
                value={ZONE.DOM.DESKTOP.OUTSTREAM}
                error={errors.PREBID_GUMGUM_ZONE_DD_OUTSTREAM}
                helperText={errors.PREBID_GUMGUM_ZONE_DD_OUTSTREAM && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.GUMGUM.ZONE.DOM.DESKTOP.OUTSTREAM = value
                  setErrors({ ...errors, PREBID_GUMGUM_ZONE_DD_OUTSTREAM: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
            <TableCell style={{ verticalAlign: 'top', textAlign: 'center' }}>
              <TextField
                margin='none'
                value={ZONE.DOM.MOBILE.OUTSTREAM}
                error={errors.PREBID_GUMGUM_ZONE_DM_OUTSTREAM}
                helperText={errors.PREBID_GUMGUM_ZONE_DM_OUTSTREAM && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.GUMGUM.ZONE.DOM.MOBILE.OUTSTREAM = value
                  setErrors({ ...errors, PREBID_GUMGUM_ZONE_DM_OUTSTREAM: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
            <TableCell style={{ verticalAlign: 'top', textAlign: 'center' }}>
              <TextField
                margin='none'
                value={ZONE.INTL.DESKTOP.OUTSTREAM}
                error={errors.PREBID_GUMGUM_ZONE_ID_OUTSTREAM}
                helperText={errors.PREBID_GUMGUM_ZONE_ID_OUTSTREAM && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.GUMGUM.ZONE.INTL.DESKTOP.OUTSTREAM = value
                  setErrors({ ...errors, PREBID_GUMGUM_ZONE_ID_OUTSTREAM: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
            <TableCell style={{ verticalAlign: 'top', textAlign: 'center' }}>
              <TextField
                margin='none'
                value={ZONE.INTL.MOBILE.OUTSTREAM}
                error={errors.PREBID_GUMGUM_ZONE_IM_OUTSTREAM}
                helperText={errors.PREBID_GUMGUM_ZONE_IM_OUTSTREAM && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.GUMGUM.ZONE.INTL.MOBILE.OUTSTREAM = value
                  setErrors({ ...errors, PREBID_GUMGUM_ZONE_IM_OUTSTREAM: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    )
  }

  const displayMappingsTable = (field, fieldId, fieldName, errorField) => {
    return (
      <Table size='small' aria-label='gumgum-dynamic-mapping-table'>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: '180px' }} />
            <TableCell colSpan={2} style={{ textAlign: 'center' }}>DOMESTIC</TableCell>
            <TableCell colSpan={2} style={{ textAlign: 'center' }}>INTERNATIONAL</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ width: '180px' }}></TableCell>
            <TableCell style={{ textAlign: 'center' }}>DESKTOP</TableCell>
            <TableCell style={{ textAlign: 'center' }}>MOBILE</TableCell>
            <TableCell style={{ textAlign: 'center' }}>DESKTOP</TableCell>
            <TableCell style={{ textAlign: 'center' }}>MOBILE</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <Typography variant='h6' style={{ fontWeight: 'bolder' }}>{fieldName}</Typography>
            </TableCell>
            <TableCell style={{ verticalAlign: 'top', textAlign: 'center' }}>
              <TextField
                margin='none'
                value={field.DOM.DESKTOP}
                error={errors[errorField + 'DD']}
                helperText={errors[errorField + 'DD'] && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.GUMGUM[fieldId].DOM.DESKTOP = value
                  setErrors({ ...errors, [errorField]: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
            <TableCell style={{ verticalAlign: 'top', textAlign: 'center' }}>
              <TextField
                margin='none'
                value={field.DOM.MOBILE}
                error={errors[errorField + 'DM']}
                helperText={errors[errorField + 'DM'] && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.GUMGUM[fieldId].DOM.MOBILE = value
                  setErrors({ ...errors, [errorField]: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
            <TableCell style={{ verticalAlign: 'top', textAlign: 'center' }}>
              <TextField
                margin='none'
                value={field.INTL.DESKTOP}
                error={errors[errorField + 'ID']}
                helperText={errors[errorField + 'ID'] && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.GUMGUM[fieldId].INTL.DESKTOP = value
                  setErrors({ ...errors, [errorField]: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
            <TableCell style={{ verticalAlign: 'top', textAlign: 'center' }}>
              <TextField
                margin='none'
                value={field.INTL.MOBILE}
                error={errors[errorField + 'IM']}
                helperText={errors[errorField + 'IM'] && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.GUMGUM[fieldId].INTL.MOBILE = value
                  setErrors({ ...errors, [errorField]: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    )
  }

  const setNestedSlot = (loc, device, path, val) => {
    const slot = PREBID.VENDOR.GUMGUM.SLOT[loc][device]
    if (!slot.DISPLAY) slot.DISPLAY = {}
    const base = slot.DISPLAY
    let curr = base
    for (let i = 0; i < path.length - 1; i++) {
      const key = path[i]
      if (!curr[key]) curr[key] = {}
      curr = curr[key]
    }
    curr[path[path.length - 1]] = isNaN(Number(val)) ? val : Number(val)
    setOptions({ ...options, PREBID })
    setAllOptions({ ...allOptions, PREBID })
  }

  const getNestedSlot = (loc, device, path) => {
    const base = SLOT[loc]?.[device]?.DISPLAY
    if (!base) return ''
    let curr = base
    for (const key of path) {
      curr = curr?.[key]
      if (curr === undefined) return ''
    }
    return curr ?? ''
  }

  const displaySlotMappingTable = () => {
    const rosSlotRulesDesktop = [
      { label: 'rect_btf_06', path: ['ROS', 'RECT', 'BTF', '06'], desc: 'ROS rect_btf_06 (Desktop)' },
      { label: 'rect_300x250', path: ['ROS', 'RECT', '300x250'], desc: 'ROS rect 300x250 (excl. rect_btf_06)' },
      { label: 'bnr_atf_01 728x90', path: ['ROS', 'BNR', 'ATF', '01', '728x90'], desc: 'ROS bnr_atf_01 728x90 (Desktop)' },
      { label: 'right_atf_01 300x250', path: ['ROS', 'RIGHT', 'ATF', '01', '300x250'], desc: 'ROS right_atf_01 300x250 (Desktop)' },
      { label: 'multi_atf_01', path: ['ROS', 'MULTI', 'ATF', '01'], desc: 'ROS multi_atf_01 (Desktop & Mobile)' },
      { label: 'multi 728x90', path: ['ROS', 'MULTI', '728x90'], desc: 'ROS multi 728x90 excl. multi_atf_01 (Desktop)' },
      { label: 'multi default', path: ['ROS', 'MULTI', 'default'], desc: 'ROS multi excl. multi_atf_01 (Mobile)' },
    ]
    const rosSlotRulesMobile = [
      { label: 'rect_300x250', path: ['ROS', 'RECT', '300x250'], desc: 'ROS rect 300x250 (excl. rect_btf_06)' },
      { label: 'multi_atf_01', path: ['ROS', 'MULTI', 'ATF', '01'], desc: 'ROS multi_atf_01 (Desktop & Mobile)' },
      { label: 'multi default', path: ['ROS', 'MULTI', 'default'], desc: 'ROS multi excl. multi_atf_01 (Mobile)' },
    ]
    return (
      <Table size='small' aria-label='gumgum-slot-mapping-table'>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: '220px' }}><Typography variant='h6' style={{ fontWeight: 'bolder' }}>Slot Mappings</Typography></TableCell>
            <TableCell style={{ textAlign: 'center' }}>DOMESTIC</TableCell>
            <TableCell style={{ textAlign: 'center' }}>INTERNATIONAL</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Display Desktop</TableCell>
            <TableCell>
              <Grid container spacing={2}>
                {rosSlotRulesDesktop.map((rule, idx) => (
                  <Grid item xs={12} sm={12} md={4} key={`ros-dom-d-${idx}`}>
                    <TextField
                      margin='none'
                      label={rule.label}
                      value={getNestedSlot('DOM', 'DESKTOP', rule.path)}
                      error={errors[`PREBID_GUMGUM_ROS_DOM_D_${idx}`]}
                      helperText={errors[`PREBID_GUMGUM_ROS_DOM_D_${idx}`] && LENGTH.message}
                      onChange={(event) => {
                        const value = event.target.value
                        setNestedSlot('DOM', 'DESKTOP', rule.path, value)
                        setErrors({ ...errors, [`PREBID_GUMGUM_ROS_DOM_D_${idx}`]: value.length < LENGTH.min || value.length > LENGTH.max })
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container spacing={2}>
                {rosSlotRulesDesktop.map((rule, idx) => (
                  <Grid item xs={12} sm={12} md={4} key={`ros-intl-d-${idx}`}>
                    <TextField
                      margin='none'
                      label={rule.label}
                      value={getNestedSlot('INTL', 'DESKTOP', rule.path)}
                      error={errors[`PREBID_GUMGUM_ROS_INTL_D_${idx}`]}
                      helperText={errors[`PREBID_GUMGUM_ROS_INTL_D_${idx}`] && LENGTH.message}
                      onChange={(event) => {
                        const value = event.target.value
                        setNestedSlot('INTL', 'DESKTOP', rule.path, value)
                        setErrors({ ...errors, [`PREBID_GUMGUM_ROS_INTL_D_${idx}`]: value.length < LENGTH.min || value.length > LENGTH.max })
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Display Mobile</TableCell>
            <TableCell>
              <Grid container spacing={2}>
                {rosSlotRulesMobile.map((rule, idx) => (
                  <Grid item xs={12} sm={12} md={4} key={`ros-dom-m-${idx}`}>
                    <TextField
                      margin='none'
                      label={rule.label}
                      value={getNestedSlot('DOM', 'MOBILE', rule.path)}
                      error={errors[`PREBID_GUMGUM_ROS_DOM_M_${idx}`]}
                      helperText={errors[`PREBID_GUMGUM_ROS_DOM_M_${idx}`] && LENGTH.message}
                      onChange={(event) => {
                        const value = event.target.value
                        setNestedSlot('DOM', 'MOBILE', rule.path, value)
                        setErrors({ ...errors, [`PREBID_GUMGUM_ROS_DOM_M_${idx}`]: value.length < LENGTH.min || value.length > LENGTH.max })
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container spacing={2}>
                {rosSlotRulesMobile.map((rule, idx) => (
                  <Grid item xs={12} sm={12} md={4} key={`ros-intl-m-${idx}`}>
                    <TextField
                      margin='none'
                      label={rule.label}
                      value={getNestedSlot('INTL', 'MOBILE', rule.path)}
                      error={errors[`PREBID_GUMGUM_ROS_INTL_M_${idx}`]}
                      helperText={errors[`PREBID_GUMGUM_ROS_INTL_M_${idx}`] && LENGTH.message}
                      onChange={(event) => {
                        const value = event.target.value
                        setNestedSlot('INTL', 'MOBILE', rule.path, value)
                        setErrors({ ...errors, [`PREBID_GUMGUM_ROS_INTL_M_${idx}`]: value.length < LENGTH.min || value.length > LENGTH.max })
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </TableCell>
          </TableRow>
        </TableBody>
        </Table>
      )
    }

  // const displaySlotMappingTable = () => {
  //   return (
  //     <Table size='small' aria-label='gumgum-slot-mapping-table'>
  //       <TableHead>
  //         <TableRow>
  //           <TableCell style={{ width: '180px' }}><Typography variant='h6' style={{ fontWeight: 'bolder' }}>Slot Mappings</Typography></TableCell>
  //           <TableCell style={{ textAlign: 'center' }}>DOMESTIC</TableCell>
  //           <TableCell style={{ textAlign: 'center' }}>INTERNATIONAL</TableCell>
  //         </TableRow>
  //       </TableHead>
  //       <TableBody>
  //         <TableRow>
  //           <TableCell>Display Desktop</TableCell>
  //           <TableCell>
  //             <Grid container spacing={2}>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='HP atf'
  //                   value={SLOT.DOM.DESKTOP.HP.atf}
  //                   error={errors.PREBID_GUMGUM_SLOT_DD_HP_A}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_DD_HP_A && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.DOM.DESKTOP.HP.atf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='HP btf'
  //                   value={SLOT.DOM.DESKTOP.HP.btf}
  //                   error={errors.PREBID_GUMGUM_SLOT_DD_HP_B}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_DD_HP_B && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.DOM.DESKTOP.HP.btf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='ROS atf'
  //                   value={SLOT.DOM.DESKTOP.ROS.atf}
  //                   error={errors.PREBID_GUMGUM_SLOT_DD_ROS_A}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_DD_ROS_A && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.DOM.DESKTOP.ROS.atf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_DD_ROS_A: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='ROS btf'
  //                   value={SLOT.DOM.DESKTOP.ROS.btf}
  //                   error={errors.PREBID_GUMGUM_SLOT_DD_ROS_B}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_DD_ROS_B && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.DOM.DESKTOP.ROS.btf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_DD_ROS_B: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //             </Grid>
  //           </TableCell>
  //           <TableCell>
  //             <Grid container spacing={2}>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='HP atf'
  //                   value={SLOT.INTL.DESKTOP.HP.atf}
  //                   error={errors.PREBID_GUMGUM_SLOT_ID_HP_A}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_ID_HP_A && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.INTL.DESKTOP.HP.atf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_ID_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='HP btf'
  //                   value={SLOT.INTL.DESKTOP.HP.btf}
  //                   error={errors.PREBID_GUMGUM_SLOT_ID_HP_B}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_ID_HP_B && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.INTL.DESKTOP.HP.btf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_ID_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='ROS atf'
  //                   value={SLOT.INTL.DESKTOP.ROS.atf}
  //                   error={errors.PREBID_GUMGUM_SLOT_ID_ROS_A}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_ID_ROS_A && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.INTL.DESKTOP.ROS.atf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_ID_ROS_A: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='ROS btf'
  //                   value={SLOT.INTL.DESKTOP.ROS.btf}
  //                   error={errors.PREBID_GUMGUM_SLOT_ID_ROS_B}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_ID_ROS_B && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.INTL.DESKTOP.ROS.btf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_ID_ROS_B: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //             </Grid>
  //           </TableCell>
  //         </TableRow>
  //         <TableRow>
  //           <TableCell>Display Mobile</TableCell>
  //           <TableCell>
  //             <Grid container spacing={2}>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='HP atf'
  //                   value={SLOT.DOM.MOBILE.HP.atf}
  //                   error={errors.PREBID_GUMGUM_SLOT_ID_DM_HP_A}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_ID_DM_HP_A && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.DOM.MOBILE.HP.atf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_ID_DM_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='HP btf'
  //                   value={SLOT.DOM.MOBILE.HP.btf}
  //                   error={errors.PREBID_GUMGUM_SLOT_ID_DM_HP_B}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_ID_DM_HP_B && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.DOM.MOBILE.HP.btf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_ID_DM_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='ROS atf'
  //                   value={SLOT.DOM.MOBILE.ROS.atf}
  //                   error={errors.PREBID_GUMGUM_SLOT_ID_DM_ROS_A}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_ID_DM_ROS_A && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.DOM.MOBILE.ROS.atf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_ID_DM_ROS_A: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='ROS btf'
  //                   value={SLOT.DOM.MOBILE.ROS.btf}
  //                   error={errors.PREBID_GUMGUM_SLOT_ID_DM_ROS_B}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_ID_DM_ROS_B && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.DOM.MOBILE.ROS.btf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_ID_DM_ROS_B: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //             </Grid>
  //           </TableCell>
  //           <TableCell>
  //             <Grid container spacing={2}>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='HP atf'
  //                   value={SLOT.INTL.MOBILE.HP.atf}
  //                   error={errors.PREBID_GUMGUM_SLOT_ID_INTL_HP_A}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_ID_INTL_HP_A && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.INTL.MOBILE.HP.atf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_ID_INTL_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='HP btf'
  //                   value={SLOT.INTL.MOBILE.HP.btf}
  //                   error={errors.PREBID_GUMGUM_SLOT_ID_INTL_HP_B}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_ID_INTL_HP_B && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.INTL.MOBILE.HP.btf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_ID_INTL_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='ROS atf'
  //                   value={SLOT.INTL.MOBILE.ROS.atf}
  //                   error={errors.PREBID_GUMGUM_SLOT_ID_INTL_ROS_A}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_ID_INTL_ROS_A && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.INTL.MOBILE.ROS.atf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_ID_INTL_ROS_A: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //               <Grid item xs={12} sm={12} md={6}>
  //                 <TextField
  //                   margin='none'
  //                   label='ROS btf'
  //                   value={SLOT.INTL.MOBILE.ROS.btf}
  //                   error={errors.PREBID_GUMGUM_SLOT_ID_INTL_ROS_B}
  //                   helperText={errors.PREBID_GUMGUM_SLOT_ID_INTL_ROS_B && LENGTH.message}
  //                   onChange={(event) => {
  //                     const value = event.target.value
  //                     PREBID.VENDOR.GUMGUM.SLOT.INTL.MOBILE.ROS.btf = value
  //                     setErrors({ ...errors, PREBID_GUMGUM_SLOT_ID_INTL_ROS_B: value.length < LENGTH.min || value.length > LENGTH.max })
  //                     setOptions({ ...options, PREBID })
  //                     setAllOptions({ ...allOptions, PREBID })
  //                   }}
  //                 />
  //               </Grid>
  //             </Grid>
  //           </TableCell>
  //         </TableRow>
  //       </TableBody>
  //     </Table>
  //   )
  // }
  
  return (
    <ExpansionPanel expanded={expanded}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='gumgum-panel-content'
        id='gumgum-panel-header'
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant='h5'>GumGum</Typography>
      </ExpansionPanelSummary>
      <Divider />
      <ExpansionPanelDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>{displayZoneIDTable()}</Grid>
          <Grid item xs={12}>{displayMappingsTable(PUB_ID, 'PUB_ID', 'Publisher ID', 'ggpid')}</Grid>
          <Grid item xs={12}>{displaySlotMappingTable()}</Grid>
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}
